import { Chip as MUIChip, ChipProps as MUIChipProps } from "@mui/material";
import classNames from "classnames";
import "./Chip.scss";

type CustomChipVariants = "bubble";
type CombinedChipVariants = MUIChipProps["variant"] | CustomChipVariants;

interface ChipProps extends Omit<MUIChipProps, "variant"> {
  variant?: CombinedChipVariants;
}

export const Chip = ({
  className,
  onDelete = undefined,
  variant = "filled",
  ...rest
}: ChipProps) => {
  const classes = classNames("Chip", className, {
    "Chip--bubble": variant === "bubble",
  });

  const muiVariant = variant === "bubble" ? "filled" : variant;

  return <MUIChip className={classes} variant={muiVariant} {...rest} />;
};
